<template>
    <el-drawer
        title="添加用户"
        :visible.sync="drawer"
        :modal="true"
        :wrapperClosable="false"
        size="600px"
        @close="closeDrawer"
        :modal-append-to-body="false"
        :direction="direction">

        <!-- title -->
        <div class="drawer_form">
            
            <el-form :model="form" status-icon :rules="rules" ref="form" label-width="120px" class="demo-ruleForm">
                
                <div class="form-body">
                    <overlay-scrollbars style="width: 100%;height: 100%;" class="el-fade-in">
                        <!-- <el-form-item label="部门" prop="">
                            <el-select v-model="form.deptId" class="w-full" placeholder="请选择">
                                <el-option
                                v-for="item in dept_lists"
                                :key="item.id"
                                :label="item.name"
                                :value="item.id">
                                </el-option>
                            </el-select>
                        </el-form-item> -->
                        <el-form-item label="真实姓名" prop="">
                            <el-input type="text" v-model="form.name" autocomplete="off"></el-input>
                        </el-form-item>
                        <el-form-item label="用户名" prop="username">
                            <el-input type="text" v-model="form.username" autocomplete="off"></el-input>
                        </el-form-item>
                        <!-- <el-form-item label="角色" prop="">
                            <el-select v-model="form.roleIds" class="w-full" multiple placeholder="请选择">
                                <el-option
                                v-for="item in role_lists"
                                :key="item.id"
                                :label="item.name"
                                :value="item.id">
                                </el-option>
                            </el-select>
                        </el-form-item> -->
                        <el-form-item label="手机号" prop="">
                            <el-input type="text" v-model="form.phone" autocomplete="off"></el-input>
                        </el-form-item>
                        <el-form-item label="密码" prop="">
                            <el-input type="text" v-model="form.password"  show-password></el-input>
                        </el-form-item>
                    </overlay-scrollbars>
                </div>

                <div class="form-foot d-flex a-center j-center">
                    <el-button @click="onSubmit" type="primary" class="" style="width:200px">添加</el-button>
                </div>
            </el-form>
        </div>

    </el-drawer>
    
</template>

<script>
import {lists} from '@/request/api/role'
import {all} from '@/request/api/departments'
import {create as user_create} from '@/request/api/user'
export default {
    data(){
        return {
            drawer: true, //表单
            direction: 'rtl',//抽屉方向
            loading:false,
            form:{
                // deptId:'',
                // roleIds:[],
                name:'',
                username:'',
                password:'',
                phone:''
            },
            role_lists:[],//role
            dept_lists:[],
            rules:{
                username:[
                    { required: true, message: '用户名必填', trigger: 'blur' },
                ],
            }
        }
    },
    created(){
        this.getRole()
        this.getDepartments()
    },
    methods:{
        onSubmit(){
            this.$refs['form'].validate((valid) => {
                if (valid) {
                    this.req()
                } else {
                    return false;
                }
            });
        },
        
        //req
        async req(){
            
            let {code,msg} =await user_create(this.form);
            if(code!=0) return this.$notify({title: '创建失败',message: msg,type: 'error'});
            this.$notify({title: '成功',message: msg,type: 'success'});
            this.$router.go(-1)
        },

        //获取角色
        async getRole()
        {
            let {code,data} = await lists()
            if(code!=0) return;
            this.role_lists = data
        },


        async getDepartments()
        {
            let {code,data} = await all()
            if(code!=0) return;
            this.dept_lists = data
        },


        //重置表单
        resetForm(formName) {
            this.$refs[formName].resetFields();
        },

        //关闭抽屉
        closeDrawer(){
            this.$router.go(-1)
        }
    }

}
</script>


<style lang="less" scoped>
.drawer_form {
    width: 96%;
    margin: auto;
    .drawer_form_title {
        color: #17233d;
        font-size: 22px;
        font-weight: 400;
        text-align: center;
        line-height: 48px;
        margin-bottom: 20px;
    }

    .drawer_line {
        margin-bottom: 30px;
        .drawer_line_text {
            width: 120px;
            margin-right: 20px;
            text-align: right;
            color: #515a6e;
        }    
    }

}
.form-items {
    background-color:#f5f6fb;padding:15px 10px;height:500px;
}

/deep/ .form-items .el-form-item ,/deep/ .form-items .el-form-item .el-form-item__content{
    width: 100%;
}

</style>

